import { enqueueSnackbar } from 'notistack';
import { createAction } from 'redux-actions';

import { getMessage } from '@gef-ui/localization/messages';

import fetch from 'features/common/fetch';

import * as types from './actionTypes';

export const addCampaignState = createAction(types.ADD_CAMPAIGN_STATE, (statusId) => ({ statusId }));
export const enableSave = createAction(types.ENABLE_SAVE, (enable) => ({ enable }));
export const removeCampaignState = createAction(types.REMOVE_CAMPAIGN_STATE, (statusId) => ({ statusId }));
export const setCampaignStates = createAction(types.SET_CAMPAIGN_STATE, (states) => ({ states }));
export const updateCampaignStates = createAction(types.UPDATE_CAMPAIGN_STATES, (ids) => ({ ids }));

export const fetchCampaignState = (campaignId) => (dispatch) => {
	dispatch(
		fetch.actions.get(fetch.constants.urls.campaignStatus, {
			replaceParams: { id: campaignId },
			onSuccess: [
				(response) => () => {
					const data = response.body;
					if (!data || !Array.isArray(data)) return;
					dispatch(setCampaignStates(data));
				},
			],
		}),
	);
};

export const saveCampaignState = (campaignId, statuses) => (dispatch) => {
	dispatch(
		fetch.actions.put(fetch.constants.urls.campaignStatus, {
			replaceParams: { id: campaignId },
			body: { statuses },
			onSuccess: [
				() => () => {
					enqueueSnackbar(getMessage('toastr:approveCampaignContactStates'), { variant: 'success' });
					dispatch(enableSave(true));
				},
			],
		}),
	);
};
